import { makeStyles } from "@material-ui/core";
import AutoCompleteField from "../UI/Fields/AutoCompleteField";

const useStyles = makeStyles({
  root: {
    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
      display: "none",
    },
  },
  inputRoot: {
    marginTop: "0 !important",
    paddingRight: "20px !important",
  },
  input: {
    fontSize: "0.875rem",
    fontWeight: "500 !important" as any,
    lineHeight: "1.5rem",
    width: "fit-content !important",
    padding: "4px 0 !important",
  },
  popper: {
    width: "fit-content !important",
  },
});

const MeasurementNavigation = ({ stages, currentStage, onChange }) => {
  const classes = useStyles();
  const options = stages.map((stage, index) => ({ id: index, name: stage }));

  const handleOnChangeOption = (name, value) => {
    onChange(value.id);
  };

  return (
    <>
      <AutoCompleteField
        classes={classes}
        options={options}
        name={"measuredStage"}
        value={options[currentStage]}
        onChangeOption={handleOnChangeOption}
        disableClearable={true}
        InputProps={{
          margin: "none",
          fullWidth: false,
        }}
      />
    </>
  );
};

export default MeasurementNavigation;
